
export class Edi310Header  {
    billTo : number = 0;
    billToName : string = '';
    senderID: string = '';
    receiverID:string = '';
    ftpServer :string = '';
    ftpID :string = '';
    ftpPassword :string = '';
    ftpOutFolder :string = '';
    ftpScac :string = '';
    ediSeqNo : number = 0;

    lines: Edi310Line[] = [];

    //cloud
    startDate :string = '';
    endDate :string = '';

    constructor(init?: Partial<Edi310Header>) {
        Object.assign(this, init);
        this.lines = [];
      }
}

export class Edi310Line  {
    id: number = 0;
    invoiceId: number = 0;
    invoiceNo: string = '';
    invoiceDate: string | null = null;
    dueDate: string | null = null;
    ediDate: string | null = null;
    amount: number = 0;
    selected: boolean = false;
    currency: string = '';
}

export class EdiSharedInfo  {
    id: number = 0;
    version: string = '';
    release: string = '';
    senderID: string = '';
    senderIdQualifier: string = '';
    senderName: string = '';
    receiverID: string = '';
    receiverIdQualifier: string = '';
    receiverName: string = '';
    fileName: string = '';
    ediType: string = '';

    constructor(init?: Partial<EdiSharedInfo>) {
        Object.assign(this, init);
      }
}

